export default __webpack_public_path__ + "static/media/Delivery_Tracking_Dark.f11c01bf.svg";